import styled from "styled-components";

const FooterActionButton = (props) => {
  const { children, classNameWrapper } = props;
  return (
    // <WrapperParent className="footer-wrap-parent">
    //   <Wrapper className={classNames(`${footerStyle} footer-wrapper`)}>{children}</Wrapper>
    // </WrapperParent>
    <Wrapper>
      <div className={`${classNameWrapper} footer-wrapper`}>{children}</div>
    </Wrapper>
  );
};

export default FooterActionButton;

const Wrapper = styled.div`
  h3 {
    color: #5e7079;
    font-family: "Roboto";
    font-size: 14px;
    font-weight: 500;
  }
  .footer-wrapper {
    border-top: 2px solid #eee;
    width: 100%;
    padding: 12px 35px;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0px;
    right: 0px;
    background-color: #fff;
    z-index: 9;
    border-radius: 0 0 15px 15px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 12px 20px;
    }
    .icon-btn {
      margin-top: 16px;
      font-size: 16px;
      background-color: #1ec252;
      color: #fff;
      padding: 3px 14px;
      font-family: Roboto;
      font-weight: 500;
      border-radius: 8px;
      /* border: 1.56px solid #27ce0a; */
      cursor: pointer;
      text-transform: capitalize;
      width: 100%;
      display: block;
      text-align: center;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
      &.disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }
    .footer-btn {
      font-size: 16px;
      color: #27ce0a;
      padding: 3px 14px;
      font-family: "helveticaneuebold";
      font-weight: 700;
      border-radius: 17px;
      border: 1.56px solid #27ce0a;
      cursor: pointer;
      text-transform: capitalize;
      width: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
      &.disabled {
        opacity: 0.5;
        pointer-events: none;
      }
      &.mr {
        margin-right: 15px;
      }
      &.filled-success {
        background-color: #27ce0a;
        color: #fff;
      }
    }
  }
`;
